export default __webpack_public_path__ + "static/media/cardesign.1a6df524.png";